import React, {useEffect, useRef, useState} from 'react';
import Header from './Header';
import OrderSummary from './orderSummary/OrderSummary';
import SqField from '../nbn/SqField';
import globals from '../globals';
import sqAnimations from '../nbn/Nbn/sqAnimations';
import FlipToFibrePlans from "./FlipToFibrePlans";
import NbnExtras from '../../../data/flip-to-fibre/nbn-extras.json';
import { useMedia } from "react-use";
import FlipToFibreInterimPlans from "./FlipToFibreInterimPlans";
import InterimPlan from '../../../data/flip-to-fibre/interim-plan.json';
import thingsToKnow from "../../../data/flip-to-fibre/flip-to-fibre-things-to-know.json";
import ExpandableListModule from "../modules/ExpandableListModule";
import { BRAND_EXETEL, NO_CONTRACT, UNCONNECTED_SERVICES_CAMPAIGNS } from "../constants";
import { appendAgentTokenInput } from '../utils/agentUtil';
import DataSource from '../DataSource';
import { appendGenesysIdInput } from '../utils/addGenesysId';
import { appendUtmSourceId } from '../utils/utmUtil';

const FlipToFibre = (props) => {
    const isMobile = useMedia("(max-width: 992px)");

    const [address, setAddress] = useState(globals.getSessionVar('address'));
    const [addressList, setAddressList] = useState([]);
    const [response, setResponse] = useState(globals.getSqFromSessionStorage() ? globals.getSqFromSessionStorage() : null);
    const [hasError, setHasError] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isAbleToF2F, setIsAbleToF2F] = useState(false);

    const [selectedContract, setSelectedContract] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState({})
    const [selectedPlanId, setSelectedPlanId] = useState('');
    const [selectedExtras, setSelectedExtras] = useState(['modem']);
    const [charges, setCharges] = useState({
        monthlyTotal: 0,
        upfrontTotal: 0,
        minCharge: 0
    })
    const [selectedInterimPlan, setSelectedInterimPlan] = useState({})
    const [deviceQuantity, setDeviceQuantity] = useState(1);
    const [providerName, setProviderName] = useState([globals.getSqFromSessionStorage().priority ? globals.getSqFromSessionStorage().priority : null])
    const [locationId, setLocationId] = useState([globals.getSqFromSessionStorage().locId ? globals.getSqFromSessionStorage().locId : null])

    const containerRef = useRef(null);

    const headerStep = ['Scalable and secure internet to keep your business operational 24/7', 'Dedicated account manager with prioritised business support when you need it', 'Specialised activation teams to help set you up']


    const handleSqSubmit = async (sqField) => {
        if (address && locationId.length > 0 && providerName.length > 0) {
            sqAnimations.showLoader(sqField);
            let tl = sqAnimations.triggerProgressBar(sqField);
            globals.pushGA4Events("sqAddressSubmitBusiness", {
                eventInfo: {
                    userPostCode: globals.sqAddressResult(address).userPostcode,
                    userState: globals.sqAddressResult(address).userState,
                    pageCategory: "Business"
                }
            });

            const onSuccess = response => {
                sqAnimations.completeLoader(sqField, tl);
                setHasError(false)
                setResponse(response)
                if (response.services.includes('nbn')) {
                    globals.setSessionVar('sq', JSON.stringify(response))
                    globals.pushGA4Events("sqSubmitSuccessBusiness", {
                        eventInfo: {
                            technologyType: response.fibreType ? response.fibreType : response.nbnType,
                            userPostCode: globals.sqAddressResult(address).userPostcode,
                            userState: globals.sqAddressResult(address).userState,
                            pageCategory: "Business",
                            unconnected: response.campaigns.includes(UNCONNECTED_SERVICES_CAMPAIGNS)  
                        }
                    });
                } else {
                    globals.setSessionVar('sq', '')
                }
                globals.setLocalVar('nbnSpeed', response.maxSpeed);
                sqAnimations.showSuccess(sqField)
                setIsClicked(false)
                getData()
            }

            const params = {}
            if (providerName.length > 0) {
                providerName.forEach((provider, index) => params[provider.toLowerCase()] = locationId[index])
            }

            params['brand'] = BRAND_EXETEL

            await DataSource.getServiceQualification(params, response => {
                const apiResponse = providerName.length > 1 ? response.sqSummary.nbn : response.sqSummary[providerName[0].toLowerCase()]

                const result = {
                    sqClass: apiResponse.serviceClass,
                    nbnNewDev: apiResponse.newDevelopmentsChargeApplies,
                    nbnType: apiResponse.technologyShortCode ? apiResponse.technologyShortCode: apiResponse.technology,
                    fibreType: /(uniti)/i.test(providerName) ? 'OptiComm' : (/(vision)/i.test(providerName) ? 'Vision' : ''),
                    hasFibre: /(uniti|vision)/i.test(providerName),
                    nbnRegion: 'metro',
                    locId: apiResponse.locationId,
                    flipReady: apiResponse.alternativeTechnologyDetails && apiResponse.alternativeTechnologyDetails.readyStatus ? apiResponse.alternativeTechnologyDetails.readyStatus : false,
                    flipDate: apiResponse.alternativeTechnologyDetails && apiResponse.alternativeTechnologyDetails.readyDate ? apiResponse.alternativeTechnologyDetails.readyDate : "",
                    nbnReadyDate: apiResponse.readyDate,
                    maxSpeed: apiResponse.maximumDownloadSpeed,
                    earliestChangeoverDate: null,
                    completedDate: null,
                    services: providerName.map(name => name === 'nbn' || name === 'NBN' ? 'nbn' : 'fibre'),
                    additionalServices: [],
                    categories: response.sqSummary.availablePlanCategories,
                    priority: response.sqSummary ? response.sqSummary.priority[0] === 'uniti' ? 'fibre' : response.sqSummary.priority[0] : '',
                    campaigns: apiResponse.campaigns && apiResponse.campaigns.length > 0 ? apiResponse.campaigns : []
                }

                onSuccess(result)
            }, () => {
                sqAnimations.completeLoader(sqField, tl)
                sqAnimations.resetSq(sqField)
                setHasError(true)
                globals.pushGA4Events("sqSubmitFailBusiness", {
                    eventInfo: {
                        addressOutcome: "Service is not available",
                        userPostCode: globals.sqAddressResult(address).userPostcode,
                        userState: globals.sqAddressResult(address).userState,
                        pageCategory: "Business"
                    }
                });
            })
        }
    }

    const handleAddressClick = (address) => {
        if (address.address) {
            setLocationId(address.locationId)
            setProviderName(address.name)
            setAddress(address.address)
            setIsClicked(true)
        }
    }

    const handleEnterPress = () => {
        /*
            If the user presses enter while there are addresses in state then
            automatically submit the first value
        */
        if (addressList.length > 0) {
            handleAddressClick(addressList[0]);
        } else {
            handleSqSubmit();
        }
    }

    const handleResetAddressList = () => {
        setAddressList([]);
    }

    const getData = () => {
        let url = `/api/getDefaultPlansSmbNbn`;
        if (props.sqClass && props.nbnMaxSpeed) {
            url = `/api/getPlansSmbNbn/${props.sqClass}/${props.nbnMaxSpeed}`;
        }

        fetch(url)
            .then(response => response.json())
            .then((response) => {
                setDefaultValues(response);
            });
    }

    const setDefaultValues = (result) => {
        let contractType = NO_CONTRACT,
            defaultPlan = result[contractType],
            selectedPlanId = defaultPlan[2].id,
            selectedPlan = defaultPlan[2];

        const nbnPlans = defaultPlan.filter(item => item.planSpeed !== 'nbn50');

        setSelectedContract(nbnPlans);
        setSelectedPlanId(selectedPlanId);
        setSelectedPlan(selectedPlan);
        setSelectedInterimPlan(InterimPlan[0]);
    }

    const calcMonthlyPrice = (plan) => {
        let price = plan.price;
        if (plan.special && plan.special.planPrice) {
            price = plan.special.planPrice;
        }

        return price;
    }

    const calculateTotal = () => {
        let monthlyTotal = calcMonthlyPrice(selectedPlan),
            upfrontTotal = 0;

        if (selectedExtras.length > 0) {
            selectedExtras.forEach((key) => {
                upfrontTotal += key === 'extender' ? NbnExtras.extras[key].upfrontPrice * deviceQuantity + NbnExtras.extras[key].deliveryFee : NbnExtras.extras[key].upfrontPrice + NbnExtras.extras[key].deliveryFee;
            })
        }

        let minCharge = monthlyTotal * 18 + upfrontTotal;

        setCharges({
            monthlyTotal,
            upfrontTotal,
            minCharge
        });
    };

    const handleChangeSpeed = (planId, index) => {
        setSelectedPlan(selectedContract[index]);
        setSelectedPlanId(planId);
    }

    const handleChangeInterimPlan = (planId, index) => {
        setSelectedInterimPlan(InterimPlan[index]);
    }

    const handleAddToCart = (item) => {
        let selectedDevices = [];
        if (!selectedExtras.includes(item)) {
            selectedDevices.push(item);
        }
        setSelectedExtras(prevstate => [...prevstate, ...selectedDevices]);
    }

    const handleRemoveFromCart = (device) => {
        const removedExtras = selectedExtras.filter(item => item !== device);
        setSelectedExtras(removedExtras);
    }

    const updateCart = (action) => {
        setDeviceQuantity(prevState => action === 'add' ? prevState + 1 : action === 'remove' ? prevState > 1 ? prevState - 1 : 1 : 0);
    }


    const checkIfFlipToFibreAvailable = (sqResult) => {
        return sqResult.flipReady && sqResult.flipDate !== '';
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!selectedPlanId) {
            return;
        }

        let form = document.createElement('form'),
            data = {
                type: 'broadband',
                technology: 'fibre',
                sq_address: globals.encryptData(address),
                service_class: '0',
                flip: 1,
                interim_plan: selectedInterimPlan.planFullSpeed === 'nbn 50/20' ? 50 : 100,
                plan_id: selectedPlanId,
                contract_term: 12,
                unlimited_phone: 0,
                payg_phone: 0,
                modem: (selectedExtras.includes('modem') ? 1 : 0),
                hs: 'trial',
                extender: (selectedExtras.includes('extender') ? deviceQuantity : 0),
                fdclid: '',
                new_dev: 0,
                smb: 1
            };
        
        const planName = selectedPlan.planTitle
        const totalMinCost = charges.minCharge
        const interimPlanName = selectedInterimPlan.planTitle
        const price = selectedPlan.special.planPrice ? selectedPlan.special.planPrice : selectedPlan.price
        const interimPlanPrice = selectedInterimPlan.price
        const extenderQuantity = deviceQuantity

        globals.pushEventNbnOrderNowBusiness({ ...data, planName, totalMinCost, isFlipToFibrePage: true, interimPlanName })
        globals.pushEventSelectItem({...data, planName, totalMinCost, price, interimPlanName,interimPlanPrice, extenderQuantity })


        Object.keys(data).map((key) => {
            let input = document.createElement('input');
            input.name = key;
            input.type = 'hidden';
            input.value = data[key];
            form.appendChild(input);
        });

        appendAgentTokenInput(form)
        appendUtmSourceId(form)
        appendGenesysIdInput(form)

        form.method = 'GET';
        form.action = process.env.MIX_APP_ORDER_FORM_URL;

        document.body.appendChild(form);
        form.submit();
    }

    useEffect(() => {
        getData();
        if (isClicked) {
            handleSqSubmit(containerRef.current)
        }
    }, [isClicked]);

    useEffect(() => {
        if (locationId.length > 0 && providerName.length > 0 && Object.keys(globals.getSqFromSessionStorage()).length > 0) {
            handleSqSubmit(containerRef.current)
        }
    }, [])

    useEffect(() => {
        calculateTotal();
    }, [selectedPlan, selectedExtras, deviceQuantity]);

    useEffect(() => {
        setIsAbleToF2F(checkIfFlipToFibreAvailable(response));
    }, [response]);

    return (
        <div className="flipToFibrePage nbn-plans">
            <div className="d-none d-lg-block">
                <Header steps={headerStep}/>
                <br/><br/>
                <h1 className="text-center mt-3">First, we need to see if your business is eligible. </h1>
            </div>
            <div id="sq-field-trigger"/>
            <div className="d-lg-none">
                <Header steps={headerStep}/>
                <h1 className="text-center m-0 px-3 font-size-26">First, we need to see if your business is eligible. </h1>
            </div>
            <div className="nbn-plans-inner py-0">
                <div className="green-border" ref={containerRef}>
                    <SqField
                        address={address}
                        addressList={addressList}
                        setAddressList={setAddressList}
                        handleAddressClick={handleAddressClick}
                        handleSqSubmit={handleSqSubmit}
                        handleEnterPress={handleEnterPress}
                        resetAddressList={handleResetAddressList}
                        isFlipToFibre={true}
                        response={response}
                        hasError={hasError}
                    />
                </div>
            </div>
            <div className="flipToFibre-body">                                 
                <div className="flipToFibre-container py-5">
                    <div className="d-flex align-items-center flex-column" id="f2f-plans">
                        <h1 className="py-lg-5 my-lg-3 mt-lg-5 text-center mt-4">It’s time to choose your unlimited nbn®
                            business plan. </h1>
                        <FlipToFibrePlans
                            plans={selectedContract}
                            calcMonthlyPrice={calcMonthlyPrice}
                            handleChangeSpeed={handleChangeSpeed}
                            selectedPlan={selectedPlan}
                        />
                    </div>
                    <p className={`font-tiny py-lg-5 pb-3 px-5 text-center`}>Subject to service qualification.
                        See Things you need to know for details.
                        <br />
                        <a className="bold" href={`https://files.exetel.com.au/cis/smb/nbn/2025-09/Exetel_SMB_CIS_nbn.pdf`}
                           target="_blank"> Broadband critical info.</a>
                        <a className="bold" href="https://files.exetel.com.au/terms/Business_NBN_Key_Facts_Sheet.pdf"
                           target="_blank"> Key fact sheet.</a>                        
                    </p>
                    <div className={`d-flex flex-column ${!isMobile ? "align-items-center" : ""}`}>
                        <h1 className="text-center d-none d-lg-block m-0">Choose your interim nbn® plan.</h1>
                        <h5 className="text-center d-lg-none font-size-26 px-5 m-0">You’ll need an interim nbn™ plan</h5>
                        <p className="col-12 col-md-6 col-lg-5 text-center my-lg-5">
                            Worried about downtime? With our interim business nbn® plans there is none. Simply choose
                            one of the below to tide you over, and once the transfer is complete your chosen
                            business fibre plan will automatically kick-in.
                        </p>
                        <FlipToFibreInterimPlans plans={InterimPlan} selectedInterimPlan={selectedInterimPlan} handChangeInterimPlan={handleChangeInterimPlan}/>
                        <div className={`pt-5 d-flex flex-column ${!isMobile ? "col-lg-offset-2 pl-lg-5" : ""}`}>
                            <h3 className="col-12 col-md-6 col-lg-6 m-0">Important information</h3>
                            <p className="col-12 col-md-6 col-lg-10">Once your new ultra-fast business fibre service has been activated, any unused portion of your interim nbn® plan will be turned into a prorated credit and added to your account.</p>
                        </div>
                    </div>
                </div>
            </div>
            <OrderSummary
                data={NbnExtras}
                monthlyTotal={charges.monthlyTotal}
                upfrontTotal={charges.upfrontTotal}
                minCharge={charges.minCharge}
                selectedPlan={selectedPlan}
                calcMonthlyPrice={calcMonthlyPrice}
                selectedExtras={selectedExtras}
                selectedInterimPlan={selectedInterimPlan}
                handleRemoveFromCart={handleRemoveFromCart}
                handleAddToCart={handleAddToCart}
                updateCart={updateCart}
                quantity={deviceQuantity}
                isAbleToF2F={isAbleToF2F}
                handleSubmit={handleSubmit}
            />

            <div className="separator" />
            <div className="things-to-know pt-5">
                <ExpandableListModule title="Things you need to know" data={thingsToKnow.needToKnow} hasPadding={false} />
            </div>
        </div>
    );
}

export default FlipToFibre;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/FlipToFibre.js